module.exports = __webpack_public_path__ + "img/warrior horned devil.jpg";